<template>
  <div class="p-5 bg-white">
    <div class="flex justify-start space-x-4 tabs">
      <span v-for="tab in tabs" :key="tab.key" @click="curTab = tab.key"
        class="tab flex-center px-2 rounded py-1 bg-gray-100 text-gray-500 cursor-pointer"
        :class="{ 'active': curTab == tab.key }">{{ tab.name }}</span>
    </div>
    <div class="space-y-10 pt-6" >
      <div class="list" v-for="item in commentLists" :key="item.id">
        <div v-if="item.user && item.user.id" class="flex items-center space-x-2">
          <img :src="$smallImage(item.user.icon)" class="icon">
          <span>{{ item.user.name }}</span>
        </div>
        <div v-else class="flex items-center space-x-2">
          <img :src="logo" class="icon">
          <span>{{ item.user }}</span>
        </div>
        <div class="flex justify-start py-4 pl-11">
          {{ item.content }}
        </div>
        <div class="img-lists pl-11" v-if="item.images">
          <div class="img-box" v-for="(img, index) in item.images.split(';')" :key="index">
            <img :src="$smallImage(img)">

          </div>
        </div>
      </div>
    </div>
    <div class=" flex-center py-30" v-if="!pager.total">
      {{ pager.total }}
      <img src="@/assets/image/暂无数据.png">
      </div>
    <el-pagination background layout="prev, pager, next" :total="pager.total" :page-size="pager.size"  @current-change="pageChange">
    </el-pagination>
  </div>
</template>
<script>
import { ref, onMounted, computed, watch } from "@vue/composition-api"
export default {
  props: {
    sid: [Number, String]
  },
  setup(props, ctx) {
    const logo = ctx.root.$logo
    const curTab = ref('all')
    const tabs = [{
      key: 'all',
      name: ctx.root.$t('全部'),
      nums: 0
    },
    {
      key: 'new',
      name: ctx.root.$t('最新')
    },
    {
      key: 'good',
      name: ctx.root.$t('好评')
    },
    {
      key: 'bad',
      name: ctx.root.$t('中差评')
    },
    {
      key: 'image',
      name: ctx.root.$t('有图')
    }
    ]
    const param = computed(() => {
      let obj = {
        sid: props.sid
      }
      switch (curTab.value) {
        case 'new':
          obj.orderby = '-created'
          break;
        case 'good':
          obj.q__serscore__gte = 4
          break;
        case 'bad':
          obj.q__serscore__lte = 4
          break;
        case 'image':
          obj.q__images__isnull = 'False'
          break;
      }
      return obj
    })
    const commentLists = ref([])
    const pager = new ctx.root.$Pager({
      apiname: 'getSupplierComment',
      param: () => (param.value),
      onLoaded: (res) => {
        if (res.code == 0 && res.data) {
          commentLists.value = res.data.items
        }
      }
    })
    onMounted(async () => {
      await pager.first()
    })

    watch(() => param.value, async () => {
      await pager.first()
    })

    const pageChange = async(val) => {
      await pager.load(val)
    }
    return { tabs, curTab, commentLists, logo, pager,pageChange }
  }
}
</script>
<style scoped lang="scss">.tabs .tab.active {
  --tw-bg-opacity: 1;
  background-color: rgba(21, 186, 99, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.list {
  display: grid;
}
.list .icon {
  width: 2.38rem;
  height: 2.28rem;
  border-radius: 50%;
}
.list .img-lists {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-column-gap: 0.4rem;
}
.list .img-lists .img-box {
  position: relative;
  width: 100%;
  height: 0px;
  padding-top: 100%;
}
.list .img-lists .img-box img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}</style>